import type { RouteRecordRaw } from 'vue-router';

export const cADMIN_ROUTES = {
  auth: {
    path: '',
    name: 'AuthAdmin',
    meta: {
      requiresAuth: false,
      routeAdmin: true,
    },

    loginAPI: {
      path: 'login',
      name: 'LoginAdmin',
      component: () => import('@/modules/auth/api/AuthAPI.vue'),
    },
  },

  admin: {
    path: '',
    name: 'Admin',
    meta: {
      requiresAuth: true,
      routeAdmin: true,
    },

    informativoVersoes: {
      path: 'versoes',
      name: 'InformativoVersoes',
      component: () => import('@/modules/temas/tema-administrativo/pages/informativo-versoes/InformativoVersoes.vue'),
    },

    monitoramentoConexoes: {
      path: 'conexoes',
      name: 'MonitoramentoConexoes',
      component: () =>
        import('@/modules/temas/tema-administrativo/pages/monitoramento-conexoes/MonitoramentoConexoes.vue'),
    },

    manutencaoAPI: {
      path: 'manutencao',
      name: 'ManutencaoAPI',
      component: () => import('@/modules/temas/tema-administrativo/pages/manutencao-api/ManutencaoAPI.vue'),
    },

    monitoramentoFila: {
      path: 'fila',
      name: 'MonitoramentoFila',

      filaProcessamento: {
        path: 'processamento',
        name: 'MonitoramentoFilaProcessamento',
        component: () =>
          import('@/modules/temas/tema-administrativo/pages/monitoramento-fila/MonitoramentoFilaProcessamento.vue'),
      },

      filaUpload: {
        path: 'upload',
        name: 'MonitoramentoFilaUpload',
        component: () =>
          import('@/modules/temas/tema-administrativo/pages/monitoramento-fila/MonitoramentoFilaUpload.vue'),
      },
    },

    controleUsuario: {
      path: 'controle-usuario',
      name: 'ControleUsuario',
      component: () => import('@/modules/temas/tema-administrativo/pages/controle-usuario/ControleUsuario.vue'),
    },

    perfilAcesso: {
      path: 'perfil-acesso',
      name: 'PerfilDeAcessoAdministrativo',
      component: () => import('@/modules/temas/tema-administrativo/pages/perfil-acesso/PerfilAcessoAPI.vue'),
    },

    relatorio: {
      path: 'relatorio',
      name: 'RelatorioAdministrativo',

      historicoAcesso: {
        path: 'frequencia-acesso',
        name: 'HistoricoDeAcessoDeUsuarios',
        component: () =>
          import(
            '@/modules/temas/tema-administrativo/pages/relatorio/frequencia-acesso/RelatorioFrequenciaAcessoUsuario.vue'
          ),
      },

      frequenciaAtualizacao: {
        path: 'frequencia-atualizacao',
        name: 'FrequenciaDeAtualizacao',
        component: () =>
          import(
            '@/modules/temas/tema-administrativo/pages/relatorio/frequencia-atualizacao/RelatorioFrequenciaAtualizacao.vue'
          ),
      },

      necessidadeNovaCargaInicial: {
        path: 'necessidade-carga-inicial',
        name: 'NecessidadeNovaCargaInicial',
        component: () =>
          import(
            '@/modules/temas/tema-administrativo/pages/relatorio/necessidade-nova-carga/RelatorioNecessidadeNovaCargaInicial.vue'
          ),
      },

      tempoDeUsoAplicacao: {
        path: 'tempo-de-uso',
        name: 'TempoDeUsoAplicacao',
        component: () =>
          import(
            '@/modules/temas/tema-administrativo/pages/relatorio/tempo-de-uso-aplicacao/RelatorioTempoDeUsoAplicacao.vue'
          ),
      },

      recursosMaisUtilizados: {
        path: 'recursos-mais-utilizados',
        name: 'RecursosMaisUtilizados',
        component: () =>
          import(
            '@/modules/temas/tema-administrativo/pages/relatorio/recursos-mais-utilizados/RelatorioRecursosMaisUtilizados.vue'
          ),
      },

      consumoRecursos: {
        path: 'consumo-recursos',
        name: 'MonitoramentoConsumoRecursos',
        component: () =>
          import('@/modules/temas/tema-administrativo/pages/relatorio/consumo-recursos/RelatorioConsumoRecursos.vue'),
      },
    },

    monitoramentoHistoricoExecucao: {
      path: 'historico-execucao',
      name: 'MonitoramentoHistoricoExecucao',
      component: () =>
        import('@/modules/temas/tema-administrativo/pages/historico-execucao/MonitoramentoHistoricoExecucao.vue'),
    },

    monitoramentoLogRequisicoes: {
      path: 'log-requisicoes',
      name: 'MonitoramentoLogRequisicoes',
      component: () =>
        import('@/modules/temas/tema-administrativo/pages/monitoramento-requisicoes/MonitoramentoLogRequisicoes.vue'),
    },
  },
};

export const adminAuthRoutes: Array<RouteRecordRaw> = [
  {
    path: cADMIN_ROUTES.auth.path,
    name: cADMIN_ROUTES.auth.name,
    meta: {
      routeAdmin: cADMIN_ROUTES.auth.meta.routeAdmin, // Indica que é uma rota de autenticação para o admin
      requiresAuth: cADMIN_ROUTES.auth.meta.requiresAuth,
    },
    children: [
      {
        //Login
        path: cADMIN_ROUTES.auth.loginAPI.path,
        name: cADMIN_ROUTES.auth.loginAPI.name,
        component: cADMIN_ROUTES.auth.loginAPI.component,
      },
    ],
  },
];

export const adminRoutes: Array<RouteRecordRaw> = [
  {
    path: cADMIN_ROUTES.admin.path,
    name: cADMIN_ROUTES.admin.name,
    meta: {
      routeAdmin: cADMIN_ROUTES.admin.meta.routeAdmin, // Indica que é uma rota de administração
      requiresAuth: cADMIN_ROUTES.admin.meta.requiresAuth,
    },
    children: [
      {
        path: cADMIN_ROUTES.admin.informativoVersoes.path,
        name: cADMIN_ROUTES.admin.informativoVersoes.name,
        component: cADMIN_ROUTES.admin.informativoVersoes.component,
      },

      {
        path: cADMIN_ROUTES.admin.monitoramentoConexoes.path,
        name: cADMIN_ROUTES.admin.monitoramentoConexoes.name,
        component: cADMIN_ROUTES.admin.monitoramentoConexoes.component,
      },

      {
        path: cADMIN_ROUTES.admin.relatorio.path,
        name: cADMIN_ROUTES.admin.relatorio.name,
        children: [
          {
            path: cADMIN_ROUTES.admin.relatorio.historicoAcesso.path,
            name: cADMIN_ROUTES.admin.relatorio.historicoAcesso.name,
            component: cADMIN_ROUTES.admin.relatorio.historicoAcesso.component,
          },

          {
            path: cADMIN_ROUTES.admin.relatorio.frequenciaAtualizacao.path,
            name: cADMIN_ROUTES.admin.relatorio.frequenciaAtualizacao.name,
            component: cADMIN_ROUTES.admin.relatorio.frequenciaAtualizacao.component,
          },

          {
            path: cADMIN_ROUTES.admin.relatorio.consumoRecursos.path,
            name: cADMIN_ROUTES.admin.relatorio.consumoRecursos.name,
            component: cADMIN_ROUTES.admin.relatorio.consumoRecursos.component,
          },

          {
            path: cADMIN_ROUTES.admin.relatorio.tempoDeUsoAplicacao.path,
            name: cADMIN_ROUTES.admin.relatorio.tempoDeUsoAplicacao.name,
            component: cADMIN_ROUTES.admin.relatorio.tempoDeUsoAplicacao.component,
          },

          {
            path: cADMIN_ROUTES.admin.relatorio.recursosMaisUtilizados.path,
            name: cADMIN_ROUTES.admin.relatorio.recursosMaisUtilizados.name,
            component: cADMIN_ROUTES.admin.relatorio.recursosMaisUtilizados.component,
          },

          {
            path: cADMIN_ROUTES.admin.relatorio.necessidadeNovaCargaInicial.path,
            name: cADMIN_ROUTES.admin.relatorio.necessidadeNovaCargaInicial.name,
            component: cADMIN_ROUTES.admin.relatorio.necessidadeNovaCargaInicial.component,
          },
        ],
      },

      {
        path: cADMIN_ROUTES.admin.manutencaoAPI.path,
        name: cADMIN_ROUTES.admin.manutencaoAPI.name,
        component: cADMIN_ROUTES.admin.manutencaoAPI.component,
      },

      {
        path: cADMIN_ROUTES.admin.monitoramentoFila.path,
        name: cADMIN_ROUTES.admin.monitoramentoFila.name,
        children: [
          {
            path: cADMIN_ROUTES.admin.monitoramentoFila.filaProcessamento.path,
            name: cADMIN_ROUTES.admin.monitoramentoFila.filaProcessamento.name,
            component: cADMIN_ROUTES.admin.monitoramentoFila.filaProcessamento.component,
          },
          {
            path: cADMIN_ROUTES.admin.monitoramentoFila.filaUpload.path,
            name: cADMIN_ROUTES.admin.monitoramentoFila.filaUpload.name,
            component: cADMIN_ROUTES.admin.monitoramentoFila.filaUpload.component,
          },
        ],
      },

      {
        path: cADMIN_ROUTES.admin.controleUsuario.path,
        name: cADMIN_ROUTES.admin.controleUsuario.name,
        component: cADMIN_ROUTES.admin.controleUsuario.component,
      },

      {
        path: cADMIN_ROUTES.admin.monitoramentoLogRequisicoes.path,
        name: cADMIN_ROUTES.admin.monitoramentoLogRequisicoes.name,
        component: cADMIN_ROUTES.admin.monitoramentoLogRequisicoes.component,
      },

      {
        path: cADMIN_ROUTES.admin.monitoramentoHistoricoExecucao.path,
        name: cADMIN_ROUTES.admin.monitoramentoHistoricoExecucao.name,
        component: cADMIN_ROUTES.admin.monitoramentoHistoricoExecucao.component,
      },

      {
        path: cADMIN_ROUTES.admin.perfilAcesso.path,
        name: cADMIN_ROUTES.admin.perfilAcesso.name,
        component: cADMIN_ROUTES.admin.perfilAcesso.component,
      },
    ],
  },
];
